import React, { useEffect, useState } from "react";
import Input from "../../Components/Input/Input";
import { useLocation, useNavigate } from "react-router-dom";
import { addPgDetails } from "../../utils/api"; 
import { formValidation } from "../../utils/formValidation";
import GloabalLoader from "../../Components/Loader/GloabalLoader";
import { IndianStates, isEmpty } from "../../utils/common";
import { AlertWrapper } from "../../Components/Modal/style";

const init = {
  name: "",
  locality: "",
  city: "",
  state: "",
  addressLine: "",
  postalCode: "",
  ownerName: "",
  contactNumber: "",
  accommodationId: undefined,
  ownerParentName: "",
  policeStation: "",
  active: ""
}

const AddPg = () => {
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({...init});
  const [errors, setErrors] = useState({});
   const [message, setMessage] = useState({});
  const [districtsList,setDistrictsList] = useState([])
  const navigate = useNavigate();
  const location = useLocation();
  const pgData  = location.state || {};

  const handleInput = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleFormData = async () => {
    let error =  formValidation(userData,["active"])

           if(userData?.active === "" || userData?.active === undefined){
            error.active = "Please select status"
           }

    setErrors(error);
    if (Object.keys(error).length > 0) return;

    setLoading(true);
   

    try {
      const payload = {...userData,accommodationId:pgData?.uuid,uuid:undefined,active:Boolean(userData?.active)};
             console.log("payload",payload)
      const res = await addPgDetails(payload, isEmpty(pgData)?"add":"update"); 

      if (res?.data?.message === "SUCCESS") {
       
          setMessage({ msg: `PG ${isEmpty(pgData)?"added":"update"} successfully`, type: "success" });
        setTimeout(() => {
          navigate("/pg-list");
        }, 1200);
      } else {
          setMessage({ msg: "Something went wrong", type: "error" });
     
      }
    } catch (err) {
           setMessage({ msg: "Error occurred while submitting data.", type: "error" });
      alert("Error occurred while submitting data.");
    } finally {
      setLoading(false);
    }
  };

    const stateHandler = (e) => {
      setErrors({});
       setUserData((prev) => ({ ...prev, state: e.target.value }));
    setErrors((prev) => ({ ...prev, state: "" }));
  
      IndianStates.map((val) => {
        if (val?.name === e.target.value) {
          setDistrictsList(val.districts);
        }
      });
    };

      useEffect(() => {
        if (!isEmpty(message)) {
          setTimeout(() => {
            setMessage({});
          }, 4000);
        }
      },[message]);

      useEffect(()=>{
        if(isEmpty(pgData)) return;
        setUserData({...pgData})
        IndianStates.map((val) => {
        if (val?.name?.toLocaleLowerCase() === pgData?.state?.toLocaleLowerCase()) {
          setDistrictsList(val.districts);
        }
        })
      },[pgData])

      useEffect(()=>{
        if(isEmpty(pgData)) return;
         
         setUserData({...pgData,city:pgData?.city})
       
      },[districtsList]);

     ;
      const handleClick = () => {
      
      navigate('/pg-list')
    }
 console.log("userData",userData)
  return (
  <>
      {!isEmpty(message) && (<AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage({})}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="main_container">
        <div className="container1 flex" style={{alignItems:"center",gap:"8px",flexDirection:"row"}}>
              <div className="flex gap-10 noPrint" style={{cursor:"pointer"}} onClick={handleClick}>
            <div 
            className="noPrint"
            style={{cursor:"pointer"}}
            ><i className="fa-solid fa-arrow-left"></i></div>
            

          </div>
     
          <label>{isEmpty(pgData)?"Create New Accommodation":"Edit Accommodation"}</label>
        </div>
        <div
          className={"container_form"}
        >
        
         
          {/* Address Details */}
          <div className="shadowBox">
            {/* <div className="">
              <div className="">
                <h3>Address Details</h3>
              </div>
            </div> */}
            <div className="role role_responsive">
              <div className="retailer">
                <div className="labelname">
                  <label>Accommodation Name</label>
                  <span className="required"> *</span>
                </div>
                <Input
                  type="text"
                  placeholder="Accommodation Name"
                  name="name"
                  value={userData?.name}
                 onChange={handleInput}
                />
                {errors.name && (
                  <p className="error fs-12 mt-10">{errors?.name}</p>
                )}
              </div>
             
            </div>

            <div className="role role_responsive">
              <div className="retailer">
                <div className="labelname">
                  <label>Owner Name</label>
                  <span className="required"> *</span>
                </div>
                <Input
                  type="text"
                  placeholder="Enter Owner Name"
                  name="ownerName"
                  value={userData?.ownerName}
                 onChange={handleInput}
                />
                {errors.ownerName && (
                  <p className="error fs-12 mt-10">{errors?.ownerName}</p>
                )}
              </div>
              <div className="retailer">
                <div className="labelname">
                  <label>Owner Parent Name</label>
                  <span className="required"> *</span>
                </div>
                <Input
                  type="text"
                  placeholder="Enter Owner Parent Name"
                  name="ownerParentName"
                  value={userData?.ownerParentName}
                 onChange={handleInput}
                />
                {errors.ownerParentName && (
                  <p className="error fs-12 mt-10">{errors?.ownerParentName}</p>
                )}
              </div>
             
            </div>

            <div className="role role_responsive">
              <div className="retailer">
                <div className="labelname">
                  <label>Contact Number</label>
                  <span className="required"> *</span>
                </div>
                <Input
                  type="text"
                  placeholder="Enter Contact Number"
                  name="contactNumber"
                  value={userData?.contactNumber}
                 onChange={handleInput}
                />
                {errors.contactNumber && (
                  <p className="error fs-12 mt-10">{errors?.contactNumber}</p>
                )}
              </div>
              <div className="retailer">
                <div className="labelname">
                  <label>Address</label>
                  <span className="required"> *</span>
                </div>
                <Input
                  type="text"
                  placeholder="Enter Address"
                  name="addressLine"
                  value={userData?.addressLine}
                 onChange={handleInput}
                />
                {errors.addressLine && (
                  <p className="error fs-12 mt-10">{errors?.addressLine}</p>
                )}
              </div>
             
            </div>

            <div className="role role_responsive">
              <div className="retailer">
                <div className="labelname">
                  <label>Locality</label>
                  <span className="required"> *</span>
                </div>
                <Input
                  type="text"
                  placeholder="Enter Locality"
                  name="locality"
                  value={userData?.locality}
                 onChange={handleInput}
                />
                {errors.locality && (
                  <p className="error fs-12 mt-10">{errors?.locality}</p>
                )}
              </div>
              <div className="retailer">
                <div className="labelname">
                  <label>Police Station</label>
                  <span className="required"> *</span>
                </div>
                <Input
                  type="text"
                  placeholder="Enter Police Station"
                  name="policeStation"
                  value={userData?.policeStation}
                 onChange={handleInput}
                />
                {errors.policeStation && (
                  <p className="error fs-12 mt-10">{errors?.policeStation}</p>
                )}
              </div>
             
            </div>


            <div className="role role_responsive">
           
              <div className="retailer">
                <div className="labelname">
                  <label>State</label>
                  <span className="required"> *</span>
                </div>
                <div className="input-field">
                  <select
                    className="input_select_field"
                    value={userData.state}
                    name="state"
                    onChange={stateHandler}
                  >
                    <option value={""}>Select State</option>
                    {IndianStates &&
                      IndianStates.map((val, index) => {
                        return (
                          <option key={index} value={val.name}>
                            {val.name}
                          </option>
                        );
                      })}
                  </select>
                  {errors.state && (
                    <p className="error fs-12 mt-10">{errors?.state}</p>
                  )}
                </div>
              </div>
               <div className="retailer">
                <div className="labelname">
                  <label>District</label>
                  <span className="required"> *</span>
                </div>
                <div className="input-field">
                  <select
                    className="input_select_field"
                    value={userData.city}
                    name="city"
                    onChange={handleInput}
                  >
                    <option value={""}>Select District</option>
                    {!isEmpty(districtsList) &&
                      districtsList.map((val) => {
                        return <option value={val}>{val}</option>;
                      })}
                  </select>
                  {errors.city && (
                    <p className="error fs-12 mt-10">{errors.city}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="role role_responsive">
           
               <div className="retailer">
                <div className="labelname">
                  <label>Postal Code</label>
                  <span className="required"> *</span>
                </div>
                <Input
                  type="text"
                  placeholder="Enter Postal Code"
                  name="policeStation"
                  value={userData?.postalCode}
                 onChange={handleInput}
                />
                {errors.postalCode && (
                  <p className="error fs-12 mt-10">{errors?.postalCode}</p>
                )}
              </div>
                <div className="retailer">
                <div className="labelname">
                  <label>Status</label>
                  <span className="required"> *</span>
                </div>
                <div className="input-field">
                  <select
                    className="input_select_field"
                    value={userData.active}
                    name="active"
                     onChange={handleInput}
                  >
                    <option value={""} disabled>Select State</option>
                    <option value={true} >Active</option>
                    <option value={false} >Inactive</option>
                    
                  </select>
                  {errors.active && (
                    <p className="error fs-12 mt-10">{errors?.active}</p>
                  )}
                </div>
              </div>
            </div>
          
            <div className="role role_responsive">
              <div className="retailer">
                <button
                  className="submit_btn "
                  disabled={loading}
                  onClick={() => {
                    handleFormData();
                  }}
                >
                  {isEmpty(pgData)?"Submit":"Update"}
                 
                </button>
              </div>
            </div>
          </div>
        </div>
        <>{loading && <GloabalLoader />}</>
      </div>
  </>
  );
};

export default AddPg;
